<template>
  <div class="editor-container" v-if="editor">
    <div class="editor-toolbar">
      <div class="editor-block">
        <menu-bar class="editor__header yellow-scroll" :editor="editor" />
        <editor-content :editor="editor" data-cy="editor-input" class="editor" />
      </div>

      <EmojiPicker class="emoji-picker" :select="selectEmoji" />
    </div>
    <div class="character-count" v-if="maxLength != null">
      {{ editor.storage.characterCount.characters() }}/{{ maxLength }}
    </div>
  </div>
</template>

<script>
import MenuBar from './MenuBar.vue'
import { Editor, EditorContent } from '@tiptap/vue-2'
import Mention from '@tiptap/extension-mention'
import MentionConfig from './MentionConfig'
import { CharacterCount } from '@tiptap/extension-character-count'
import { Placeholder } from '@tiptap/extension-placeholder'
import { AutoLink } from './AutoLink'
import EmojiPicker from './EmojiPicker'
import { TextStyle } from '@tiptap/extension-text-style'
import { Color } from '@tiptap/extension-color'
import { StarterKit } from '@tiptap/starter-kit'
import FontFamily from '@tiptap/extension-font-family'
import FontSize from 'tiptap-extension-font-size'

export default {
  components: {
    EmojiPicker,
    EditorContent,
    MenuBar
  },
  props: {
    onChange: {
      type: Function,
      default: () => {
      }
    },
    onLinkAdded: {
      type: Function,
      default: () => {
      }
    },
    initialValue: {
      type: String,
      default: ''
    },
    users: {
      type: Array,
      default: () => []
    },
    maxLength: {
      type: Number,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    editorApi: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    return {
      editor: null,
      emojiPickerVisible: false
    }
  },
  methods: {
    selectEmoji(emoji) {
      this.editor.chain().focus().insertContent(emoji).run()
    },
    toggleEmojiPicker(event) {
      this.emojiPickerVisible = !this.emojiPickerVisible
      // fix event propagation launching the click-outside directive...
      event.stopPropagation()
    },
    hideEmojiPicker() {
      this.emojiPickerVisible = false
    }
  },
  mounted() {
    let onUpdate = ({ editor }) => this.onChange(editor.getHTML(), editor.storage.characterCount.characters())
    // exclude current user
    let items = this.users.filter(user => user.id !== this.$store.getters.user.id).map(user => ({
      id: user.id,
      label: user.firstName + ' ' + user.lastName
    }))
    this.editor = new Editor({
      editorProps: {
        transformPastedHTML(html) {
          return html.replace(/<[^>]+>/g, '')
        }
      },
      extensions: [
        StarterKit,
        TextStyle,
        Color,
        FontSize,
        FontFamily,
        AutoLink.configure({
          linkAdded: this.onLinkAdded
        }),
        Placeholder.configure({
          placeholder: this.placeholder
        }),
        Mention.configure(MentionConfig(items)),
        CharacterCount.configure({
          limit: this.maxLength
        })
      ],
      content: this.initialValue,
      onUpdate: onUpdate
    })
    this.editorApi(this.editor)
  },

  beforeDestroy() {
    this.editor.destroy()
  }
}
</script>

<style lang="scss">

.editor__header {
  display: flex;
  background-color: rgb(248, 248, 248);
  color: #515051;
  border-radius: 0.5rem 0.5rem 0 0;
  white-space: nowrap;
  max-height: 35px;
  position: relative;
}

.ProseMirror {

  text-align: start;
  padding: 1em;

  & > * + * {
    margin-top: 0.75em;
  }

  *:first-child {
    margin-top: 0;
  }

  *:last-child {
    margin-bottom: 0;
  }

  .mention {
    cursor: unset;
  }
}

.editor-container {
  width: 100%;
}

.editor-block {
  width: calc(100% - 35px);
  border-color: #d8d8d8;
  border-width: 1px 1px 1px 1px;
  border-style: solid;
  border-radius: 0.5rem;
  z-index: 1;

  &:focus-within {
    .menu-item {
      color: #888588;
    }

    border-color: #b6b2b6;
  }
}

.editor-toolbar {
  display: flex;
  align-items: center;

  .editor {
    flex-grow: 1;
  }

}

.editor {
  background-color: white;
  border-radius: 0 0 0.5rem 0.5rem;
  @media (max-width: $small) {
    max-height: 70px;
    overflow-y: auto;
  }
}

.ProseMirror:focus-visible {
  outline: none
}

.mention {
  color: $secondary-color;
  background-color: rgba($secondary-color, 0.1);
  border-radius: 0.3rem;
  padding: 0.1rem 0.3rem;
  cursor: pointer;
}

.emoji-picker {
  //margin-left: 9px;
  //flex: none;

  @media (max-width: $small) {
    margin-left: 0;
  }
}
</style>
<style lang="scss">
.container-emoji{
  height: 20vh !important;
}
</style>
